import React, { useEffect, useState } from 'react';
import { IconButton, FormControl, InputAdornment, Tooltip, Grid, Select, Box, Container, Typography, InputLabel, Snackbar, SnackbarContent, Stack, Menu, MenuItem, DialogTitle, Button, TextField } from '@mui/material';
import { AccountCircle, Phone, Mail } from '@mui/icons-material';
import Title from '../../Title';
import Notify from '../../Notify';
import { getData, postData } from '../../../services/library';
import { logEventos } from '../../../services/services';

function Addcomerciales(props) {
    const [datosFormulario, setDatosFormulario] = useState({
        nombre_apellido: null,
        telefono: null,
        mail: null,
        id_supervisor: null,
        id_sucursal: null,
        usuario: localStorage.getItem("user"),
        activo: 1,
        username: null
    });

    const [supervisor, setSupervisor] = useState(null);
    const [usernames, setUsernames] = useState(null);
    const [sucursal, setSucursal] = useState(null);
    const [disBtn, setDisBtn] = useState(false)
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    //ir al formulario de supervisores 
    const handleFormSupervisores = () => {
        window.location.hash = "/supervisores"
    };

    const handleClose = () => {
        return (
            props.tabla(true),
            props.alta(false)
        )
    };

    const almacenar = (e) => {
        setDatosFormulario({ ...datosFormulario, [e.target.name]: e.target.value })
    };

    useEffect(() => {
        getData('/supervisores', setSupervisor)
        getData('/sucursales', setSucursal)
        // getData('/userdata/x/username', setUsernames)
        getData('/representantes/xusername', setUsernames)
    }, []);

    // console.log("usernames", usernames);

    const guardarComerciales = (e) => {
        setDisBtn(true)
        postData(e,
            '/representantes',
            {
                nombre_apellido: datosFormulario.nombre_apellido,
                telefono: datosFormulario.telefono,
                mail: datosFormulario.mail,
                id_supervisor: datosFormulario.id_supervisor,
                id_sucursal: datosFormulario.id_sucursal,
                usuario: localStorage.getItem("user"),
                activo: 1,
                username: datosFormulario.username
            },
            setNotificacion,
            logEventos("Agregar comercial", "Comerciales", "Tablas referencias", localStorage.getItem('user'))
        )
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    return (
        <div>
            <br />
            <Container>
                <Title titulo={" Cargar nuevo comercial"} handleClose={handleClose} />

                <form onSubmit={guardarComerciales} autoComplete='off'>
                    <Box
                        backgroundColor="#F4F6F6"
                        mt={1}
                        p={3}
                        border={0.5}
                        borderColor={"#ABB2B9"}
                        borderRadius={4}
                    >
                        <Grid container spacing={1} style={{ padding: 10 }} direction={{ xs: 'column', sm: 'row' }}>

                            <Grid item xs={6}>
                                <FormControl style={style} required focused color="primary" margin="dense">
                                    <InputLabel id="lblid_supervisor">Supervisor</InputLabel>
                                    <Select
                                        name="id_supervisor"
                                        required
                                        onChange={almacenar}
                                        value={datosFormulario.id_supervisor}
                                        label="Supervisor">
                                        {supervisor ? supervisor.map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.nombre_apellido}
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            {/* <Grid item xs={4}>
                            <Tooltip title="Agregar Supervisor">
                                <IconButton edge='end' color="primary" size="small" onClick={handleFormSupervisores}>
                                    <ControlPointIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid> */}
                            <Grid item xs={6}>
                                <FormControl style={style} focused color="primary" margin="dense" required>
                                    <InputLabel id="lblid_sucursal">Sucursal</InputLabel>
                                    <Select
                                        margin="dense"
                                        name="id_sucursal"
                                        onChange={almacenar}
                                        value={datosFormulario.id_sucursal}
                                        label="Sucursal">
                                        {sucursal ? sucursal.map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.nombre}
                                            </MenuItem>
                                        )) : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <TextField placeholder='Nombre y apellido'
                                    required
                                    focused
                                    style={style}
                                    name="nombre_apellido"
                                    label="Nombre y apellido"
                                    color="primary"
                                    inputProps={{ maxLength: 45 }}
                                    margin="dense"
                                    value={datosFormulario.nombre_apellido && datosFormulario.nombre_apellido.replace(/\b\w/g, (l) =>
                                        l.toUpperCase()
                                    )}
                                    onChange={almacenar}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <AccountCircle />
                                            </InputAdornment>
                                        )
                                    }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField placeholder='Teléfono'
                                    required
                                    focused
                                    style={style}
                                    type="number"
                                    name="telefono"
                                    label="Teléfono"
                                    color="primary"
                                    margin="dense"
                                    value={datosFormulario.telefono}
                                    onChange={almacenar}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Phone />
                                            </InputAdornment>
                                        )
                                    }} />
                            </Grid>
                            <Grid item xs={6}>
                                <TextField placeholder='E-mail'
                                    required
                                    focused
                                    style={style}
                                    type="email"
                                    name="mail"
                                    label="E-mail"
                                    color="primary"
                                    inputProps={{ maxLength: 45 }}
                                    margin="dense"
                                    value={datosFormulario.mail}
                                    onChange={almacenar}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Mail />
                                            </InputAdornment>
                                        ),
                                    }} />
                            </Grid>
                            <Grid item xs={6}>
                                <FormControl
                                    style={style}
                                    focused
                                    color="primary"
                                    required
                                    margin="dense"
                                // size={size}
                                >
                                    <InputLabel id="lbl_username">Username</InputLabel>
                                    <Select
                                        margin="dense"
                                        name="username"
                                        label="Username"
                                        value={datosFormulario.username}
                                        onChange={almacenar}
                                    >
                                        {usernames
                                            ? usernames.map((elemento) => (
                                                <MenuItem
                                                    key={elemento.username}
                                                    value={elemento.username}
                                                >
                                                    {elemento.username}
                                                </MenuItem>
                                            ))
                                            : null}
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Grid mt={2} container direction="row" justifyContent="space-between" alignItemns="center">
                            <Button variant="contained" onClick={handleClose} color="error">Volver</Button>
                            <Button disabled={disBtn} variant="contained" type="submit" color="success" >Guardar Comercial</Button>
                        </Grid>
                    </Box>
                </form>
            </Container>
            {notificacion && notificacion.open ? (
                <Notify
                    mensaje={notificacion.mensaje}
                    open={notificacion.open}
                    color={notificacion.color}
                    handleClose={handleClose}
                    severity={notificacion.severity}
                />
            ) : null}
        </div>
    )
}

export default Addcomerciales